var BookmarksPopup, DescriptionPopup, EmailPopup, ListPopup, NotesPopup, PurchasePopup, SearchPopup, SiteView, ThumbnailPopup, View, template, utils, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

View = require('views/base/view');

template = require('views/templates/site');

SearchPopup = require('views/search-popup-view');

ListPopup = require('views/list-popup-view');

BookmarksPopup = require('views/bookmarks-popup-view');

EmailPopup = require('views/email-popup-view');

NotesPopup = require('views/notes-popup-view');

DescriptionPopup = require('views/description-popup-view');

PurchasePopup = require('views/purchase-popup-view');

ThumbnailPopup = require('views/thumbnail-popup-view');

utils = require('lib/utils');

module.exports = SiteView = (function(_super) {
  __extends(SiteView, _super);

  function SiteView() {
    _ref = SiteView.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  SiteView.prototype.container = 'body';

  SiteView.prototype.id = 'site-container';

  SiteView.prototype.searchPopup = null;

  SiteView.prototype.emailPopup = null;

  SiteView.prototype.descriptionPopup = null;

  SiteView.prototype.purchasePopup = null;

  SiteView.prototype.regions = {
    '#header-container': 'header',
    '#page-container': 'main'
  };

  SiteView.prototype.template = template;

  SiteView.prototype.listen = {
    'catalogue:search:start mediator': 'createSearchPopup',
    'catalogue:list mediator': 'createListPopup',
    'catalogue:bookmarksOpen mediator': 'createBookmarksPopup',
    'catalogue:sendEmail mediator': 'createEmailPopup',
    'catalogue:notesOpen mediator': 'createNotesPopup',
    'catalogue:showDescription mediator': 'createDescriptionPopup',
    'catalogue:showAddToCartPopup mediator': 'createPurchasePopup',
    'thumnails:showPopup mediator': 'createThumbnailPopup'
  };

  SiteView.prototype.createSearchPopup = function() {
    var _ref1;
    if ((_ref1 = this.searchPopup) != null) {
      _ref1.dispose();
    }
    return this.searchPopup = new SearchPopup();
  };

  SiteView.prototype.createListPopup = function() {
    var _ref1;
    if ((_ref1 = this.listPopup) != null) {
      _ref1.dispose();
    }
    return this.listPopup = new ListPopup();
  };

  SiteView.prototype.createBookmarksPopup = function() {
    var _ref1;
    if ((_ref1 = this.bookmarksPopup) != null) {
      _ref1.dispose();
    }
    return this.bookmarksPopup = new BookmarksPopup();
  };

  SiteView.prototype.createEmailPopup = function() {
    var _ref1;
    if ((_ref1 = this.emailPopup) != null) {
      _ref1.dispose();
    }
    return this.emailPopup = new EmailPopup();
  };

  SiteView.prototype.createNotesPopup = function() {
    var _ref1;
    if ((_ref1 = this.notesPopup) != null) {
      _ref1.dispose();
    }
    return this.notesPopup = new NotesPopup();
  };

  SiteView.prototype.createDescriptionPopup = function(hotspot) {
    var _ref1;
    if (utils.isMobile.isAndroidNativeBrawser()) {
      return;
    }
    if ((_ref1 = this.descriptionPopup) != null) {
      _ref1.dispose();
    }
    return this.descriptionPopup = new DescriptionPopup({
      hotspot: hotspot
    });
  };

  SiteView.prototype.createPurchasePopup = function(model) {
    var _ref1;
    if ((_ref1 = this.purchasePopup) != null) {
      _ref1.dispose();
    }
    return this.purchasePopup = new PurchasePopup({
      model: model
    });
  };

  SiteView.prototype.createThumbnailPopup = function(activePage, position) {
    var _ref1;
    if ((_ref1 = this.thumbnailPopup) != null) {
      _ref1.dispose();
    }
    return this.thumbnailPopup = new ThumbnailPopup({
      activePage: activePage,
      position: position
    });
  };

  return SiteView;

})(View);
